<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Resource Setup"
                @search-query="(val) => (filter = val)"
                :hasClear="false"
                @create-press="
                    $router.push({ path: '/setup/Resources/addCurrency' })
                "
                @reload-data="getCurrencySetupList"
                createButtonText="Create Resource"
                :isLoading="loading"
            />
        </b-col>
        <b-col md="12">
            <b-card>
                <div>
                    <b-table
                        class="professional-stacked-table"
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        stacked="md"
                        :items="isCurrencyList"
                        :fields="currencySetupView"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        @filtered="onFilter"
                        :filter="filter"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(updatedAt)" slot-scope="data">
                            <div>{{ data.item.updatedAt | formatedate }}</div>
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <div class="d-flex">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    showDelete
                                    @view="currencyViewDetail(data.item)"
                                    @edit="editCurrency(data.item)"
                                    @delete="deleteCurrencylist(data.item)"
                                />
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="d-flex justify-content-end" v-if="isCurrencyList.length > perPage">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import { mapState, mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "Resources",
    components: {
        ComponentHeader,
        loader,
        ActionButtonGroup,
    },
    data() {
        return {
            filterCount: 0,
            filter: "",
            loading: false,
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "updatedAt",
            sortDesc: true,
            currencySetupView: [
                {
                    key: "code",
                    label: "Resource",
                },
                {
                    key: "isCurrency",
                    label: "Type",
                },
                {
                    key: "symbol",
                    label: "Symbol",
                },
                {
                    key: "name",
                    label: "Name",
                },
                {
                    key: "updatedAt",
                    label: "Last Updated",
                },
                {
                    key: "action",
                    label: "Action",
                    class: "text-center",
                    thStyle: { width: "8%" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            fetchCurrencyList: (state) => state.currency.fetchCurrencyList,
        }),
        isCurrencyList() {
            let arrayObj = [];
            this.fetchCurrencyList.map((obj) => {
                if (obj.isCurrency === true) {
                    obj.isCurrency = "Currency";
                } else {
                    obj.isCurrency = "Non - Currency";
                }
                arrayObj.push(obj);
            });
            return arrayObj;
        },
    },
    methods: {
        ...mapActions("currency", [
            "fetchCurrencySetupList",
            "currencyDeleteAction",
        ]),
        async getCurrencySetupList() {
            this.loading = true;
            try {
                await this.fetchCurrencySetupList("y");
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            } finally {
                this.loading = false;
            }
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        async deleteCurrencylist(data) {
            const result = await this.$swal({
                title: "Delete this Currency?",
                text: "Are you sure? This will be removed?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            });
            if (!result.value) return;

            this.loading = true;
            try {
                await this.currencyDeleteAction(data._id);
                this.$swal({
                    type: "success",
                    title: "Success",
                    text: "Currency deleted successfully!",
                });
                // Row removed from store via mutation; table updates automatically
            } catch (error) {
                this.$toasted.error("Unable to delete currency");
            } finally {
                this.loading = false;
            }
        },
        async currencyViewDetail(data) {
            this.$router.push({
                name: "currencyViewDetail",
                params: { id: data._id },
            });
        },
        async editCurrency(data) {
            this.$router.push({
                name: "editCurrency",
                params: { id: data._id },
            });
        },
    },
    filters: {
        formatedate(value) {
            if (value == null || value === "") {
                return "—";
            }
            const date = moment(value);
            if (!date.isValid()) {
                return "—";
            }
            return date.format("DD-MMM-YYYY hh:mm A");
        },
    },

    async mounted() {
        this.getCurrencySetupList();
    },
};
</script>
<style scoped>
.btn-edit-resource {
    margin-right: 0.5rem;
    border-radius: 50%;
    background: #fe7b08;
    border-color: #fe7b08;
}
</style>
